export const DEFAULT = '/new';

export const HOME = '/new/home';

export const QUICK = '/new/quick';
export const QUICKRESULT = '/new/quick/result'

export const QUERYCREATE = '/new/query/create';
export const QUERYMANAGER = '/new/query/manager';

export const REPORTCREATE = '/new/report/create';
export const REPORTMANAGER = '/new/report/manager';
export const REPORTEDIT = '/new/report/edit';

export const CUSTOMREPORTCREATE = '/new/report/custom/create';
export const CUSTOMREPORTMANAGER = '/new/report/custom/manager';
export const CUSTOMREPORTRESULT = '/new/report/custom/result'
export const CUSTOMREPORTEDIT = '/new/report/custom/edit'

export const SNAPSHOTCREATE = '/new/snapshot/create';
export const SNAPSHOTMANAGER = '/new/snapshot/manager';
export const SNAPSHOTEDIT = '/new/snapshot/edit';

export const LABELMANAGER = '/new/label/manager'

export const INSIGHT = '/new/insight';
export const INSIGHTPAGE = '/new/insight/page';

export const NOTICE = '/new/notice';
export const NOTICEPAGE = '/new/notice/page'
export const NOTICEEDIT = '/new/notice/edit';
export const NOTICECREATE = '/new/notice/create';

export const ACCOUNT = '/new/account/edit';

export const LOGIN = '/new/login';

export const PRIVACY = '/new/privacy';
export const STIPULATIONS = '/new/stipulations';
export const MANAGEMENTPOLICY = '/new/managementpolicy';

export const ADMIN = '/new/admin';
export const ADMINACCOUNTEDIT = '/new/admin/account/edit';

export const TRENDVOLUME = '/new/trend/volume';
export const TRENDDETAIL = '/new/trend/detail';

// export const DEFAULT ='/';

// export const HOME = '/home';

// export const QUICK = '/quick';
// export const QUICKRESULT = '/quick/result'

// export const QUERYCREATE = '/query/create';
// export const QUERYMANAGER = '/query/manager';

// export const REPORTCREATE = '/report/create';
// export const REPORTMANAGER = '/report/manager';
// export const REPORTEDIT = '/report/edit';

// export const CUSTOMREPORTCREATE = '/report/custom/create';
// export const CUSTOMREPORTMANAGER = '/report/custom/manager';
// export const CUSTOMREPORTRESULT = '/report/custom/result';
// export const CUSTOMREPORTEDIT = '/report/custom/edit'

// export const SNAPSHOTCREATE = '/snapshot/create';
// export const SNAPSHOTMANAGER = '/snapshot/manager';
// export const SNAPSHOTEDIT = '/snapshot/edit';

// export const LABELMANAGER = '/label/manager'

// export const INSIGHT = '/insight';
// export const INSIGHTPAGE = '/insight/page';

// export const NOTICE = '/notice';
// export const NOTICEPAGE = '/notice/page'
// export const NOTICEEDIT = '/notice/edit';
// export const NOTICECREATE = '/notice/create';

// export const ACCOUNT = '/account/edit';

// export const LOGIN = '/login';

// export const PRIVACY = '/privacy';
// export const STIPULATIONS ='/stipulations';
// export const MANAGEMENTPOLICY = '/managementpolicy';

// export const ADMIN = '/admin';
